import styled from "styled-components";
import Reveal from "../components/Reveal";
import CTABanner from "../components/CTABanner";
import { Container, Section, Eyebrow } from "../components/ui";

const facts = [
  { k: "8", v: "variante, secili me përzierjen e vet" },
  { k: "6", v: "muaj zgjat një inhalator i vetëm" },
  { k: "100%", v: "vajra esencialë organikë" },
  { k: "CH", v: "prodhuar në laborator zviceran" },
];

export default function About() {
  return (
    <>
      <Top>
        <Container>
          <Reveal>
            <Eyebrow>Rreth nesh</Eyebrow>
            <H1>Aromaterapi pa komplikime</H1>
          </Reveal>
        </Container>
      </Top>

      <Section $tight>
        <Container $narrow>
          <Reveal>
            <Lead>
              Aroma Stick nisi nga një ide e thjeshtë: shumica e njerëzve nuk
              kanë kohë për rituale të gjata. Kanë një ditë të ngarkuar, një
              rrugë të gjatë përpara, ose një natë ku gjumi nuk vjen.
            </Lead>
          </Reveal>

          <Reveal delay={0.05}>
            <Prose>
              <p>
                Inhalatori është forma më e thjeshtë e aromaterapisë. Nuk ka
                nevojë për difuzor, nuk prek lëkurën, nuk lë erë nëpër dhomë.
                Hiqe kapakun, merr dy frymëmarrje, mbylle. Kaq.
              </p>
              <p>
                Vajrat tanë esencialë janë të certifikuar 100% organikë dhe
                përzierjet bëhen në një laborator në Zvicër. Secili variant ka
                një kombinim të caktuar: livandë dhe kamomil për gjumin,
                rozmarinë dhe nenexhik për fokusin, xhenxhefil për udhëtimin.
              </p>
              <p>
                Jemi të qartë edhe për atë që nuk është. Aroma Stick nuk është
                ilaç dhe nuk zëvendëson trajtimin mjekësor. Është një mjet i
                vogël, i thjeshtë dhe natyral që shumë njerëz e kanë bërë pjesë
                të ditës së tyre — dhe kthehen ta blejnë përsëri.
              </p>
            </Prose>
          </Reveal>
        </Container>
      </Section>

      <Section $alt $tight>
        <Container>
          <Facts>
            {facts.map((f, i) => (
              <Reveal key={f.k} delay={i * 0.07}>
                <Fact>
                  <FactNum>{f.k}</FactNum>
                  <FactText>{f.v}</FactText>
                </Fact>
              </Reveal>
            ))}
          </Facts>
        </Container>
      </Section>

      <Spacer />
      <CTABanner />
    </>
  );
}

const Top = styled.header`
  padding: 148px 0 0;

  ${({ theme }) => theme.bp.md} {
    padding: 190px 0 0;
  }
`;

const H1 = styled.h1`
  font-size: ${({ theme }) => theme.size.h1};
  max-width: 15ch;
`;

const Lead = styled.p`
  font-size: ${({ theme }) => theme.size.xl};
  font-family: ${({ theme }) => theme.font.display};
  line-height: 1.4;
  margin-bottom: 40px;
`;

const Prose = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
  color: ${({ theme }) => theme.colors.inkSoft};
  line-height: 1.8;
`;

const Facts = styled.div`
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(2, 1fr);

  ${({ theme }) => theme.bp.md} {
    grid-template-columns: repeat(4, 1fr);
    gap: 40px;
  }
`;

const Fact = styled.div``;

const FactNum = styled.div`
  font-family: ${({ theme }) => theme.font.display};
  font-size: ${({ theme }) => theme.size.h2};
  color: ${({ theme }) => theme.colors.brand};
  line-height: 1;
  margin-bottom: 10px;
`;

const FactText = styled.div`
  font-size: ${({ theme }) => theme.size.sm};
  color: ${({ theme }) => theme.colors.inkSoft};
  max-width: 22ch;
`;

const Spacer = styled.div`
  height: 88px;
  ${({ theme }) => theme.bp.md} {
    height: 136px;
  }
`;
